import * as React from "react";
import { FeatureCard } from "./FeatureCard";

const features = [
  {
    icon: "https://expertpeople.imgix.net/assets/images/forbrands-cart-icon.svg",
    description: "List excess inventory on Solvy manually or using the Solvy API"
  },
  {
    icon: "https://expertpeople.imgix.net/assets/images/forbrands-cloud-icon.svg",
    description: "List one-of a kind pieces developed exclusively for Solvy for profit, donation or both"
  },
  {
    icon: "https://expertpeople.imgix.net/assets/images/forbrands-hand-icon.svg",
    description: "Donate product to Solvy outright"
  }
];

export default function FeaturesSection() {
  return (
    <div 
      className="tw-flex tw-flex-col md:tw-flex-row tw-gap-6 tw-items-center tw-self-center tw-mt-32 tw-text-xl tw-font-semibold tw-leading-7 tw-mx-auto tw-px-4"
      style={{maxWidth: "1293px"}}>
      {features.map((feature, index) => (
        <FeatureCard key={index} {...feature} />
      ))}
    </div>
  );
}
